import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import {FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select} from "@mui/material";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import ReactPaginate from "react-paginate";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Button from "@mui/material/Button";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {toast} from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import {getAlLSerialNumbers, messageReset} from "../store/serial_numbers";

function TrackTypes(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'));
    const navigate = useNavigate()

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success("Success", {theme: 'colored'})
            props.messageReset()
        } else if (props.message === 'error') {
            toast.error("Error", {theme: 'colored'})
            props.messageReset()
        } else if (props.message === true) {
            toast.success("Success", {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])


    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token !== 'undefined') {
            const data = {
                "token": JSON.parse(token)
            }
            props.getAllVerifyResponse(data)
        }
    }, [])


    useEffect(() => {
        if (props.verify === false) {
            navigate("/login/");
        }
    }, [props])


    // New function to handle navigation to serial-numbers with type parameter
    function navigateToSerialNumbers(type) {
        navigate(`/serial-numbers?type=${type}`);
    }

    return <div>
        <div className={'page worker-page serial_numbers'}>
            <Header/>
            <Dashboard/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                }}>
                <Toolbar/>
                <div className={'main'}>
                    <div className={'header-page'}>
                        <h2 className={'page-title'}>{"Buyurtma turi"}</h2>
                    </div>

                    {/* New buttons section */}
                    <div className={'type-buttons'} style={{marginBottom: '20px', display: 'flex', gap: '10px'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => navigateToSerialNumbers('avia')}
                            style={{textTransform: 'none'}}
                        >
                            AVIA
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => navigateToSerialNumbers('fura')}
                            style={{textTransform: 'none'}}
                        >
                            FURA
                        </Button>
                    </div>
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.serial_numbers, {getAlLSerialNumbers, getAllVerifyResponse, messageReset})(TrackTypes)